// src/components/common/ChartCard.js
import React from 'react';
import { Card, CardContent, Typography, Box, Divider, useTheme } from '@mui/material';

const ChartCard = ({ title, subtitle, chart, height = 300, actions }) => {
  const theme = useTheme();
  
  return (
    <Card sx={{ 
      height: '100%', 
      borderRadius: '12px',
      backgroundColor: theme.palette.background.paper,
      boxShadow: `0 8px 16px rgba(0, 0, 0, 0.1)`,
    }}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h6" fontWeight="medium">
            {title}
          </Typography>
          {actions && (
            <Box display="flex" gap={1}>
              {actions}
            </Box>
          )}
        </Box>
        
        {subtitle && (
          <Typography variant="body2" color="text.secondary" mb={2}>
            {subtitle}
          </Typography>
        )}
        
        <Divider sx={{ mb: 2, opacity: 0.1 }} />
        
        <Box height={height}>
          {chart || (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
              <Typography color="text.secondary">No data available</Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChartCard;